<template>
  <InnerContainer :title="templateData?.pageTitle" :sub-title="templateData?.problem">
    <template #default
      ><div class="tree-view">
        <MindTree :tree-data="stableContent" /></div
    ></template>
  </InnerContainer>
</template>

<script setup lang="ts">
import InnerContainer from "@/views/grammar/newGrammar/components/InnerContainer.vue";
import MindTree from "@/views/grammar/newGrammar/components/MindTree.vue";
import { ref, defineProps, computed } from "vue";

const props = defineProps({
  templateData: {
    type: Object,
  },
});

// 确保传递给MindTree的数据是稳定的
const stableContent = computed(() => {
  return props.templateData?.content || [];
});
</script>

<style scoped lang="less">
.tree-view {
  background: white;
  border-radius: 0.5rem;
  padding: 1.01rem;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
</style>
